import React, { FunctionComponent } from "react";
import { BrandLogoBase } from "./BrandLogoBase";

interface BrandLogoSmallProps {
  brandLogo: string;
  brandName: string;
}

export const BrandLogoSmall: FunctionComponent<BrandLogoSmallProps> = (
    props: BrandLogoSmallProps
) => {
    return (
        <div
            style={{
                display: "inline-block",
                position: "relative",
            }}
        >
            <BrandLogoBase
                brandLogo={props.brandLogo}
                brandName={props.brandName}
                height="30px"
                width="30px"
            />
        </div>
    );
};
